import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";

export const PageTitleWrapper = styled.div`
  margin-bottom: 36px;
`;

export const FormTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
`;

export const ButtonText = styled.div`
  ${typography.label_large};
  color: ${palette.colors.green_base};
  cursor: pointer;
  padding: 10px 12px;
  transition: all ease-in-out 0.1s;

  &:hover {
    background-color: ${palette.colors.button_text_hover};
    border-radius: ${shape.rounding.XXL};
  }
`;

export const FieldGroupWrapper = styled.div`
  margin-bottom: 36px;
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const FieldGroup = styled.div`
  margin: 36px 0;
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const CheckBoxWrapper = styled.div`
  margin-bottom: 36px;
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  margin-bottom: 16px;
  justify-content: flex-start;
`;

export const LoginForm = styled.div`
  & > form {
    padding-bottom: 0 !important;
  }
`;
